﻿$(function () {
    puritanLawn.search = {
        selectedDeceasedId: null,
        selectedDeceasedName: null,
        onSelectCallback: null,
        show: function (title, onSelectCallback) {
            $("#pl-searchModalTitle").html(title);
            puritanLawn.search.onSelectCallback = onSelectCallback;
            $('#pl-searchModal').modal();
        },
        beforeSearch: function () {
            $(".pl-searchModalSearchResult").off("click", puritanLawn.search.select);
            $("#pl-searchModalSearchButton").prop('disabled', true);
            $("#pl-searchModalSearchButton i:first-of-type").hide();
            $("#pl-searchModalSearchButton span:first-of-type").show();
        },
        afterSearch: function (results) {
            if (results) renderSearchResults(results);

            $("#pl-searchModalSearchButton").prop('disabled', false);
            $("#pl-searchModalSearchButton span:first-of-type").hide();
            $("#pl-searchModalSearchButton i:first-of-type").show();

            if (results) $(".pl-searchModalSearchResult").on("click", puritanLawn.search.select);
        },
        select: function () {
            var deceasedId = $(this).attr("data-pl-deceasedId");
            var deceasedLFM = $(this).attr("data-pl-deceasedLFM");

            puritanLawn.search.onSelectCallback(deceasedId, deceasedLFM);

            $('#pl-searchModal').modal('hide');
        }
    }

    // Initialize search input
    $('#pl-searchModalSearchInput').keydown(function (event) {
        if (event.keyCode == 13) {
            $("#pl-searchModalSearchButton").click();
        }
    });

    $('#pl-searchModalSearchInput').keyup(function () {
        var value = $(this).val();

        if (value.length < 3) {
            $('#pl-searchModalSearchButton').prop('disabled', true);
        } else {
            $('#pl-searchModalSearchButton').prop('disabled', false);
        }
    });

    $('#pl-searchModalSearchInput').keyup();

    // Initialize search button
    $("#pl-searchModalSearchButton").on("click", function () {
        var query = $('#pl-searchModalSearchInput').val();

        puritanLawn.search.beforeSearch();

        puritanLawn.ajaxGet(puritanLawn.adminServicesBaseAddress + 'Search/?query=' + query,
            function (results) {
                puritanLawn.search.afterSearch(results);
            },
            function (response) {
                console.log(response);
                alert("error");
                puritanLawn.search.afterSearch();
            }
        );

        return false;
    });

    function renderSearchResults(searchResults) {
        var source = document.getElementById("pl-searchModalSearchResultsTemplate").innerHTML;
        var template = Handlebars.compile(source);
        var html = template(searchResults);

        //detachImageElements();

        $("#pl-searchModalSearchResults").html(html);

        //attachImageElements();
    }
});